import React from 'react';
import { useAuth } from '../../../contexts';
import { getMenuItems } from '../../../utils/menuConfig';
import { Button } from '../../atoms/Button';
import { NavigationItem } from '../../molecules/NavigationItem';
import { SidebarHeader } from '../../molecules/SidebarHeader';

export interface SidebarProps {
  onLogout: () => void;
  currentPath?: string;
  isOpen?: boolean;
  onClose?: () => void;
}

export const Sidebar = ({
  onLogout,
  currentPath,
  isOpen = true,
  onClose
}: SidebarProps) => {
  const { user } = useAuth();
  const menuItems = getMenuItems(user);

  return (
    <>
      {/* Mobile overlay */}
      {isOpen && (
        <div
          className="fixed inset-0 bg-black bg-opacity-50 z-40 lg:hidden"
          onClick={onClose}
        />
      )}

      {/* Sidebar */}
      <aside className={`
        fixed lg:static inset-y-0 left-0 z-50
        w-64 bg-white border-r border-gray-200 min-h-screen flex flex-col shadow-lg
        transform transition-transform duration-300 ease-in-out
        ${isOpen ? 'translate-x-0' : '-translate-x-full lg:translate-x-0'}
      `}>
        <SidebarHeader
          onClose={onClose}
          showCloseButton={true}
        />

        <nav className="flex-1 p-4 overflow-y-auto">
          <ul className="space-y-4">
            {menuItems.map((section, sectionIndex) => (
              <li key={sectionIndex}>
                {section.heading && (
                  <h3 className="px-4 py-2 text-xs font-semibold text-gray-500 uppercase tracking-wider mb-2">
                    {section.heading}
                  </h3>
                )}
                <ul className="space-y-1">
                  {section.items.map((item) => (
                    <NavigationItem
                      key={item.path}
                      path={item.path}
                      label={item.label}
                      icon={item.icon}
                      isActive={currentPath === item.path}
                      onClick={() => {
                        // Close menu on mobile when menu item is clicked
                        if (window.innerWidth < 1024 && onClose) {
                          onClose();
                        }
                      }}
                    />
                  ))}
                </ul>
              </li>
            ))}
          </ul>
        </nav>

        <div className="p-4 border-t border-gray-100 bg-gray-50">
          <Button
            variant="danger"
            size="medium"
            onClick={onLogout}
            className="w-full shadow-sm hover:shadow-md transition-shadow"
          >
            Çıkış Yap
          </Button>
        </div>
      </aside>
    </>
  );
};

